import React, { useState } from 'react';
import { differenceInDays, endOfDay, format, startOfDay } from 'date-fns';
import { DownArrowIcon } from 'assets/icons';
import { Popover, Transition } from '@headlessui/react';
import ExpiryDateSection from '../../components/ExpiryDateSection';
import { selectExpiryDate, updateExpiryDate } from 'containers/estimates/estimatesSlice';
import { useAppDispatch, useAppSelector } from 'hooks';

const EstimateExpiry: React.FC = () => {
  const [showCustomPicker, setShowCustomPicker] = useState(false);

  const dispatch = useAppDispatch();

  const expiryDate = useAppSelector(selectExpiryDate);

  const onExpiryDateChange = (date: Date) => {
    const endOfSelectedDay = endOfDay(date);
    dispatch(updateExpiryDate(endOfSelectedDay.toISOString()));
  };

  const formatDisplayText = (date: Date) => {
    const todayStart = startOfDay(new Date());
    const expiryEnd = endOfDay(date);
    const diffDays = differenceInDays(expiryEnd, todayStart);

    if (diffDays === 0) {
      return `Today (${format(date, 'MMM d, yyyy')})`;
    }

    return `In ${diffDays} days (${format(date, 'MMM d, yyyy')})`;
  };

  return (
    <div>
      <div className="mb-2 text-17px font-semibold">Expiry date</div>
      <Popover className="relative z-20 w-1/2">
        {({ close }) => (
          <>
            <Popover.Button className="w-full">
              <div className="flex w-full items-center justify-between rounded bg-secondaryBtn py-3.5 px-5">
                <div className="text-primaryText">{expiryDate ? formatDisplayText(expiryDate) : ''}</div>
                <DownArrowIcon />
              </div>
            </Popover.Button>

            <Transition
              enter="transition duration-100 ease-out"
              enterFrom="transform scale-95 opacity-0"
              enterTo="transform scale-100 opacity-100"
              leave="transition duration-75 ease-out"
              leaveFrom="transform scale-100 opacity-100"
              leaveTo="transform scale-95 opacity-0">
              <Popover.Panel
                className="absolute z-50 mt-2 w-[400px] 
                rounded-lg bg-white p-4 shadow-lg">
                <ExpiryDateSection
                  selectedDate={expiryDate}
                  onDateChange={date => {
                    onExpiryDateChange(date);
                    close();
                  }}
                  showCustomPicker={showCustomPicker}
                  onCustomPickerChange={setShowCustomPicker}
                />
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
};

export default EstimateExpiry;
